module.exports = __webpack_public_path__ + "img/账户信息.cef4da42.png";